<div class="row mt-3">
    <div class="col-lg-12 text-end">      
      <button   (click)="editPayrate('new','00000000-0000-0000-0000-000000000000')" class="btn  btn-sm mb-2 me-1" [disabled]="global.viewTabs"  *ngIf="fp.payratecreate">Add
        Payrates</button>
    </div>
  </div>
  <ejs-grid #grid [dataSource]='data |async'[allowResizing]='true'[pageSettings]='initialPage' [filterSettings]='filterSettings'
  [allowSorting]='true' allowPaging='true' [allowFiltering]='true' (dataStateChange)='dataStateChange($event)'
  (actionBegin)="onActionComplete($event)" class="mx-1" >
  <e-columns>
    <e-column minWidth= 100 headerText="Actions" uid="action" textAlign='center'>
      <ng-template #template let-data>
        <button class="btn btn-edit-table mr-2"  [disabled]="global.viewTabs" (click)="editPayrate('edit',data)"  *ngIf="fp.payrateupdate"><i 
            class="fa fa-edit"></i></button>
            <button  [disabled]="global.viewTabs"
            class=" btn btn-delete-table ms-2 " data-bs-toggle="modal" data-bs-target="#deletemodal"  (click)="setDeleteId(data.id)"  *ngIf="fp.payratedelete">
            <i class="fa fa-trash fa-lg"></i></button>
      </ng-template>
    </e-column>
    <e-column minWidth= 100 field="clientName" headerText="Client Name" type="string">
      <ng-template #filterTemplate let-data>
        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
      </ng-template>
    </e-column>
    <e-column minWidth= 100 field="serviceName" headerText="Service" type="string">
      <ng-template #filterTemplate let-data>
        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
      </ng-template>
    </e-column>
    <e-column minWidth= 100 field="startDate" headerText="Start Date" type="date" [format]='formatOptions'></e-column>
    <e-column minWidth= 100 field="endDate" headerText="End Date" type="date" [format]='formatOptions'></e-column>
   
    <e-column minWidth= 100 field="rate" headerText="Pay Rate" type="number">
      <ng-template #filterTemplate let-data>
        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
      </ng-template>
    </e-column>   
  </e-columns>
  </ejs-grid>

  <span id="openDelete" data-bs-target="#deletemodal" data-bs-toggle="modal"></span>
  <div class="modal" id="deletemodal" data-bs-backdrop="false">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-header">Delete Record</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true"></span>
        </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-12">
              <label>Do you want to delete this record ?</label>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn blue-btn btn-sm"(click)="Delete()" >Delete</button>
          <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>




  
  